
import React from 'react';
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";

interface BlogMetaFieldsProps {
  title: string;
  slug: string;
  excerpt: string;
  onTitleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onSlugChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onExcerptChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  disabled: boolean;
}

export const BlogMetaFields = ({ 
  title, 
  slug, 
  excerpt, 
  onTitleChange, 
  onSlugChange, 
  onExcerptChange,
  disabled
}: BlogMetaFieldsProps) => {
  return (
    <div className="space-y-6">
      <div>
        <Label htmlFor="title" className="text-base font-medium">Title</Label>
        <Input
          type="text"
          id="title"
          value={title}
          onChange={onTitleChange}
          placeholder="Enter blog title"
          disabled={disabled}
          className="mt-1"
        />
      </div>

      <div>
        <Label htmlFor="slug" className="text-base font-medium">Slug</Label>
        <Input
          type="text"
          id="slug"
          value={slug}
          onChange={onSlugChange}
          placeholder="Enter blog slug (e.g. my-blog-post)"
          disabled={disabled}
          className="mt-1"
        />
        <p className="text-sm text-gray-500 mt-1">
          This will be used in the URL: edgefi.com/blog/<span className="font-mono">{slug || 'my-blog-post'}</span>
        </p>
      </div>

      <div>
        <Label htmlFor="excerpt" className="text-base font-medium">Excerpt</Label>
        <Textarea
          id="excerpt"
          value={excerpt}
          onChange={onExcerptChange}
          placeholder="Enter a brief summary of your blog post"
          rows={3}
          disabled={disabled}
          className="mt-1"
        />
        <p className="text-sm text-gray-500 mt-1">
          This will appear in blog listings and social media shares
        </p>
      </div>
    </div>
  );
};
